// src/pages/Entries.js
import React from "react";
import Login from "../components/Login/Login";

export default function LoginPage() {
  return (
    <>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh'
      }}>
        <Login />
      </div>
    </>
  );
}
